import getLang from 'I18n/utils/getLang';
export const translateService = service => service.additionalLanguages[getLang()] || service.name;